export default function propComboValidator(propValidator, propNames) {
  return function propComboValidationFunction(props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var propValidationResult = propValidator.apply(void 0, [props, propName, componentName].concat(rest));
    if (propValidationResult) return propValidationResult;
    var matchingProps = propNames.reduce(function (accum, el) {
      return props[el] ? accum + 1 : accum;
    }, 0);

    if (matchingProps !== 1) {
      return new Error("expected exactly one of: ".concat(propNames.join(', '), ".  Received ").concat(matchingProps, "."));
    }
  };
}